import { Drawer as AntDrawer } from "antd";
import { createStyles } from "antd-style";

import type { AvE2EProps } from "../../../../../components/types";
import type { DrawerProps as AntDrawerProps } from "antd/lib";

type DrawerProps = AvE2EProps & AntDrawerProps;

const useStyles = createStyles(({ token, css }) => ({
  drawer: css`
    & .ant-drawer-body {
      padding: 0;
      background-color: ${token.colorFillAlter};
    }
  `,
}));

export function JobPostDetailDrawer(props: DrawerProps) {
  const { testIdPrefix, children, ...restProps } = props;
  const { styles } = useStyles();

  return (
    <AntDrawer
      data-testid={`${testIdPrefix}-drawer`}
      className={styles.drawer}
      size="large"
      {...restProps}
    >
      {children}
    </AntDrawer>
  );
}
